import React, { Component } from "react";
import {
  Button,
  Form,
  OverlayTrigger,
  Tooltip,
  Image,
  Dropdown,
  ButtonGroup
} from "react-bootstrap";
import CreateAgendaForm from "./CreateAgendaForm";
//import GuestList from "./GuestList";
import SelectedGuestList from "./SelectedGuestList";
//import SelectIssue from "./SelectIssue";
//import SelectIssueSingle from "./SelectIssueSingle";
import {
  createMom,
  getMomDetails,
  clearMomDetails,
  loadPageInfo,
  updateMom,
  onEditMomDetails,
  deleteMOM
} from "../../actions/mom.action";
import { DROP_DOWN_VALUES } from "../../constant";
import connect from "react-redux/es/connect/connect";
import { withRouter, Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";
import moment from "moment";
// import { PATHS, ERROR_MSG, DOCUMENT_FORMATS_AGENDA } from "../../constant";
import { PATHS, ERROR_MSG, DOCUMENT_FORMATS } from "../../constant";
import { get, isArray } from "lodash";
import { guestListAction } from "../../actions/issuesListAction.actions";
import {
  dateFormatWithTime,
  isValidArray,
  getLocalstorage,
  PERMISSIONS_BY_MODULE
} from "../../helper";
import { toast } from "react-toastify";
import { LoaderPage } from "../../component/Loader";
import { DownloadAgenda } from "../../component/DownloadAgenda";
import DisplayByPermission from "../../component/DisplayByPermission";
import { DisplayAttachments } from "../reusableComponent/displayAttachments";
import { UploadAttachmentsWithTitleComponent } from "../reusableComponent/uploadAttchements";
import { DownloadExcelReport1 } from "../reusableComponent/downloadMisComponent/index1.js";
import { DownloadExcelReportAgenda } from "../reusableComponent/downloadMisComponent/agendaIndex.js";
import { DownloadExcelReport } from "../reusableComponent/downloadMisComponent";
import DisabledPPt from "../../assets/disabled-ppt.svg";
import {
  clearDownloadAgendaMeetingPptv2Action,
  downloadAgendaMeetingPptv2,
  clearDownloadAgendaMeetingPptAction,
  downloadAgendaMeetingPpt,
  downloadAgendaMeetingExcel,
  clearDownloadAgendaMeetingExcelAction,
  clearDownloadAgendaMeetingPptv2WithoutIssueAction,
  clearDownloadAgendaMeetingCabSecPptAction,
  downloadAgendaCabSecPpt,
  downloadAgendaMeetingPptv2PragatiFormat,
  clearDownloadAgendaMeetingPptv2PragatiFormatAction,
  clearDownloadUpdaloadAgendaTemplateAction,
  downloadUpdaloadAgendaTemplateAction
} from "../../actions/dowloadExcelActions";
import DownloadAgendaBrief from "../../component/DownloadAgendaBrief";
import DownloadAgendaByType from "../../component/DownloadAgenda/DownloadAgendaByType.js";
import DownloadAgendaParticipants from "../../component/DownloadAgendaParticipants";
import { SelectProjectOrdering } from "./selectProjectOrdering";
import { SendByComponent1 } from "../sendNotification/Agendaindex.js";
import { getAgendaStakeHolderAction } from "../../actions/mom.action";
import PermissionHOC from "../PermissionHOC";
import { successToastStyle, errorToastStyle } from "../../customToast";
import { getMeetingTypesDetails } from "../../actions/projectDetail.action";
import { da } from "date-fns/locale";
import htmlToFormattedText from "html-to-formatted-text";
import { AgendaDropdown } from "../reusableComponent/customSelectDropDown/AgendaDropdown.js";
import { SelectProject } from "./selectProject/SelectProject.js";
import ProjectIssueSingle from "./ProjectIssueSingle.js";
import AgendaGuestList from "./AgendaGuestList.js";
import TooltipCustom from "./TooltipCustom.js";
import { getUpcommingAgendaFlagAction } from "../../actions/pragati.action.js";
import UploadIcon from "../../assets/upload_projects.svg";
import { UploadExcel } from "../reusableComponent/uploadExcel/index.js";
import { UploadProjectsIssuesComponent } from "../reusableComponent/uploadProjectsIssues/UploadProjectsIssues.js";
import {
  ModalComponent,
  ModalTemplate,
  UploadDocComponent
} from "../../container/reusableComponent/index.js";
import UploadedListModal from "./uploadProjectIssues/UploadedListModal.js";
import { BrowseUploadComponent } from "../reusableComponent/uploadProjectsIssues/BrowseUploadComponent.js";
import { UploadErrorModal } from "./uploadProjectIssues/UploadErrorModal.js";
export class CreateAgenda extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIssues: [],
      selectedProjectIssues: [],
      showLoader: true,
      isAddIssueModalVisible: false,
      isAddProjectModalVisible: false,
      formData: this._getInitForm(),
      title: "Create",
      error: {},
      agendaId: null,
      toggleAttachementDisplay: false,
      toggleUploadDisplay: false,
      toggleBrowseDisplay: false,
      isremovingfile: false,
      addAttchementRequired: true,
      fileDto: null,
      removeFileClicked: false,
      dataUnsaved: false,
      showSelectOrderingModal: false,
      finalOrderedList: [],
      _orderedListForState: [],
      _orderedListForCentral: [],
      isUsePresetCheckedForCentral: false,
      isPresetChecked: false,
      agendaMeetingTypeDetails: [],
      isPPTChecked: false,
      selectedValue: "",
      originalGuestLists: [],
      MinistryInternal: ["Ministry Internal"],
      StateInternal: ["State Internal"],
      //listofFiles: [],
      showUploadedResultModal: false
    };
  }
  updatePresetForCentral = data => {
    this.setState({ isPresetChecked: data });
  };
  _getInitForm = () => {
    return {
      parentId: null,
      meetingDate: new Date(),
      meetingTimeFrom: "",
      meetingTimeTo: "",
      agendaName: "",
      venue: "",
      meetingMode: "VIDEO_CONFERENCE",
      meetingChairedBy: "",
      meetingStatus: "SCHEDULED",
      guests: [
        {
          email: "ps3266@gmail.com",
          emailType: "TO"
        }
      ],
      issues: [],
      users: [
        {
          emailType: "TO",
          userId: 4,
          email: "ps3266@gmail.com",
          guestCategory: "PMG",
          groupId: 4
        }
      ],
      // CR_89_PRO_ISSUE
      //meetingType: ""
      meetingType: null
    };
  };

  componentDidMount = () => {
    const user = getLocalstorage("user");
    const centralUser =
      get(user, "groupCategory") == "CENTRAL" ||
      get(user, "groupCategory") == "CENTRAL_DEPARTMENT";
    const stateUser =
      get(user, "groupCategory") == "STATE" ||
      get(user, "groupCategory") == "STATE_PMG";
    const {
      loadPageInfo,
      location,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingPptAction,
      clearDownloadAgendaMeetingExcelFile,
      getMeetingTypesDetails
    } = this.props;
    if (get(location, "state.agendaId")) {
      this.handleEditAgenda(get(location, "state.agendaId"));
      clearDownloadAgendaMeetingPptv2Action();
      clearDownloadAgendaMeetingPptAction();
      clearDownloadAgendaMeetingExcelAction();
    } else {
      this.setState({ showLoader: false });
    }
    loadPageInfo();
    getMeetingTypesDetails().then(resp => {
      if (resp && !centralUser && !stateUser) {
        this.setState({ agendaMeetingTypeDetails: resp });
      } else if (centralUser) {
        this.setState({
          agendaMeetingTypeDetails: this.state.MinistryInternal
        });
      } else if (stateUser) {
        this.setState({
          agendaMeetingTypeDetails: this.state.StateInternal
        });
      } else {
        this.setState({ agendaMeetingTypeDetails: resp });
      }
    });
  };

  componentDidUpdate(prevProps) {
    const { uploadedList } = this.props;
    if (prevProps.uploadedList !== uploadedList) {
      console.log("New Uploaded List:", uploadedList);
      if (uploadedList.errorStatus) {
        const hasValidProjects =
          uploadedList &&
          Array.isArray(uploadedList.projectsData) &&
          uploadedList.projectsData.length > 0;

        if (hasValidProjects) {
          this.setState({ showUploadedResultModal: true });
        } else {
          this.setState({ showUploadErrorModal: true });
        }
      }

      //this.setState({ showUploadedResultModal: true });
    }
  }

  handleEditAgenda = async id => {
    const { location, getPermissionsDispatch } = this.props;
    const response = await onEditMomDetails(undefined, {
      momId: id
    });
    if (get(response, "status")) {
      const data = get(response, "data", {});
      // data.fileDTOList = [
      //   {
      //     "id": 14145,
      //     "title": "Test document",
      //     "mineType": "image/png",
      //     "name": "issue_obj.PNG",
      //     "s3Url": "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/1719382835565-issue_obj.PNG",
      //     "s3FileName": null
      //   }
      // ]
      let fromTime =
        data.meetingTimeFrom &&
        moment(dateFormatWithTime(data.meetingTimeFrom));
      let toTime =
        data.meetingTimeTo && moment(dateFormatWithTime(data.meetingTimeTo));
      let guests = [];
      // for Reschedule
      data &&
        data.users.map(value => {
          return guests.push({
            emailType: value.emailType,
            groupId: value.groupId,
            userId: value.userId,
            userName: value.name,
            designation: value.designation,
            groupName: value.groupName,
            email: value.email,
            guestCategory: value.guestCategory,
            nodalOfficer: value.nodalOfficer
          });
        });
      data &&
        data.guests.map(value => {
          return guests.push({
            value,
            userName: value.email,
            emailType: value.emailType,
            email: value.email,
            guestCategory: value.guestCategory,
            groupId: value.groupId
          });
        });

      const selectedProjects = get(data, "projectsData", []);
      //console.log(selectedProjects);

      //get selected issues
      let selectedIssues = [];
      const { groupCategory } = getLocalstorage("user");

      get(data, "issuesData", []).forEach(issue => {
        if (
          (groupCategory === "PMG" &&
            (issue.status === "Pending with RM/RS" ||
              issue.status === "Under PMG Decision" ||
              issue.status === "Pending with SM" ||
              issue.status === "Pending with PMG")) ||
          (groupCategory === "STATE_PMG" &&
            (issue.status === "Under State PMG Decision" ||
              issue.status === "Pending with RD" ||
              issue.status === "Pending with RM/RS")) ||
          groupCategory === "STATE" ||
          groupCategory === "CENTRAL_DEPARTMENT" ||
          groupCategory === "CENTRAL"
        ) {
          selectedIssues.push({
            id: issue.id,
            title: issue.title,
            description: issue.description,
            createdDate: issue.createdDate,
            status: issue.status,
            recipientGroup: issue.recipientState,
            assigneeGroup: issue.assigneeGroup,
            assignedForDays: issue.modifiedDate,
            category: issue.category,
            subCategory: issue.subCategory,
            meetingDecisionDTOS: issue.meetingDecisionDTOS,
            recipientGroupCategory: issue.recipientGroupCategory,
            districtName: issue.districtName,
            duplicate: issue.duplicate,
            escalationLevelName: issue.escalationLevelName,
            secondaryMinistry: issue.secondaryMinistry,
            secondaryMinistryDepartment: issue.secondaryMinistryDepartment,
            secondaryState: issue.secondaryState,
            secondaryStateDepartment: issue.secondaryStateDepartment,
            secondaryRecipientGroupId: issue.secondaryRecipientGroupId,
            secondaryRecipientGroupName: issue.secondaryRecipientGroupName,
            project: {
              id: issue.projectId,
              totalCost: issue.totalCost,
              name: issue.projectName,
              sponsoredBy: issue.sponsoringMinistry,
              displayId: issue.displayId,
              sponsoringMinistry: issue.sponsoringMinistryCategory,
              sponsoringDepartment: issue.sponsoringDepartment,
              pli: issue.pli,
              pragatiReview: issue.pragatiReview,
              nipReview: issue.nipReview,
              pmGatiShakti: issue.pmGatiShakti,
              pmFoundationStone: issue.pmFoundationStone,
              march24: issue.march24,
              organizationName: issue.organizationName,
              projectStatusWithRespectToIssueStatus:
                issue.projectStatusWithRespectToIssueStatus,
              projectCompletionDTO: issue.projectCompletionDTO,
              projectSector: issue.projectSector,
              projectCategory: issue.projectCategory,
              projectPPList: issue.projectPPList
            },
            isSelected: true,
            issuePragatiReview: issue.issuePragatiReview,
            issuePragatiPipeLine: issue.issuePragatiPipeLine,
            latestIssueComments: issue.latestIssueComments,
            projectCreatedBy: issue.projectCreatedBy,
            recipientLabel: issue.recipientLabel
          });
        }
      });

      //calculate selectedprojectIssues array
      let activeProjectsIssues = [];
      activeProjectsIssues = selectedProjects.map(selectedProject => {
        const updatedProject = { ...selectedProject };
        updatedProject.issuesSelected = selectedIssues.filter(
          selectedIssue => selectedProject.id === selectedIssue.project.id
        );
        return updatedProject;
      });
      //console.log(activeProjectsIssues);

      this.setState({
        agendaId: id,
        title: "Edit",
        formData: {
          parentId: get(location, "state.reSchedule", null)
            ? get(location, "state.agendaId")
            : null,
          meetingDate: new Date(data.meetingDate),
          meetingTimeFrom: fromTime,
          meetingTimeTo: toTime,
          agendaName: data.agendaName,
          venue: data.venue,
          meetingMode: data.meetingMode,
          meetingType: data.meetingType,
          meetingChairedBy: data.meetingChairedBy,
          meetingStatus: data.meetingStatus,
          id: get(location, "state.reSchedule", null) ? null : data.id,
          issuesData: data.issuesData,
          issues: data.issues,
          fileDTOList: data.fileDTOList,
          meetingCreatedBy: data.meetingCreatedBy,
          agendaCreatedOn: data.agendaCreatedOn
        },
        addAttchementRequired: !(
          data.fileDTOList && data.fileDTOList.length > 0
        ),
        selectedGuests: guests,
        selectedIssues: selectedIssues,
        selectedProjectIssues: activeProjectsIssues,
        showLoader: false,
        error: {
          agendaName: {
            error: !data.agendaName,
            message: !data.agendaName && ERROR_MSG.DEFAULT_MSG
          },
          venue: {
            error: !data.venue,
            message: !data.venue && ERROR_MSG.DEFAULT_MSG
          },
          meetingMode: {
            error: !data.meetingMode,
            message: !data.meetingMode && ERROR_MSG.DEFAULT_MSG
          },
          meetingChairedBy: {
            error: !data.meetingChairedBy,
            message: !data.meetingChairedBy && ERROR_MSG.DEFAULT_MSG
          }
        },
        dataUnsaved: false
      });
    }
  };

  closeAddIssueModal = () => {
    this.setState({ isAddIssueModalVisible: false });
  };

  closeAddProjectModal = () => {
    this.setState({ isAddProjectModalVisible: false });
  };

  showAddIssueModal = (data, result) => {
    this.setState({
      isAddIssueModalVisible: true,
      result: result
    });
  };
  showAddProjectModal = (data, result) => {
    this.setState({
      isAddProjectModalVisible: true,
      result: result
    });
  };

  addProjectIssuesToAgenda = selectedProjectIssues => {
    console.log("draft agenda selectedProjectIssues", selectedProjectIssues);
    this.setState(prevState => {
      const projectArr = [];
      let selectedIssuesArr = [];
      // const oldProjects = [...prevState.selectedProjectIssues];
      //console.log(oldProjects);
      selectedProjectIssues.forEach(currentProject => {
        const selectedIssues = currentProject.issuesSelected;
        selectedIssuesArr = [...selectedIssuesArr, ...selectedIssues];
      });
      //console.log(selectedProjectIssues, [].concat(oldProjects, projectArr));
      return {
        isAddIssueModalVisible: false,
        isAddProjectModalVisible: false,
        //selectedIssues: [].concat(oldIssues, issuesArr),
        selectedProjectIssues: selectedProjectIssues,
        selectedIssues: selectedIssuesArr,
        dataUnsaved: true,
        showUploadedResultModal: false
      };
    });
  };

  addIssuesToAgenda = selectedIssues => {
    this.setState(prevState => {
      const issuesArr = [];
      const oldIssues = [...prevState.selectedIssues];
      selectedIssues.forEach(currentIssue => {
        let isIssueExist = false;
        oldIssues.forEach((oldIssue, index) => {
          if (currentIssue.id === oldIssue.id) {
            isIssueExist = true;
          }
        });
        if (!isIssueExist) {
          issuesArr.push(currentIssue);
        }
      });

      return {
        isAddIssueModalVisible: false,
        selectedIssues: [].concat(oldIssues, issuesArr),
        dataUnsaved: true
      };
    });
  };

  resetSelectedIssues = () => {
    this.setState({
      selectedIssues: []
    });
  };

  filterGuestList = (newGuestList = [], selectedGuests) => {
    let guestUserIdArray = [];
    newGuestList.map(item => guestUserIdArray.push(item.userId));
    this.setState({
      selectedGuests:
        selectedGuests &&
        selectedGuests.filter(
          item =>
            item.userAddedGuest ||
            [...new Set(guestUserIdArray)].includes(item.userId)
        )
    });
  };

  deselectProjects = idx => {
    this.setState(
      prevState => {
        const deletedProject = prevState.selectedProjectIssues.splice(idx, 1);
        const issuesNeedToDelete = deletedProject.issuesSelected;

        let updatedSelectedIssues = [];
        updatedSelectedIssues = prevState.selectedProjectIssues.reduce(
          (acc, singleProject) => {
            return acc.concat(singleProject.issuesSelected);
          },
          []
        );

        return {
          deletedProjects: deletedProject,
          selectedProjectIssues: prevState.selectedProjectIssues,
          selectedIssues: updatedSelectedIssues,
          dataUnsaved: true
        };
      },
      () => {
        const { selectedProjectIssues, selectedGuests } = this.state;
        const { guestListDispatch } = this.props;
        //const ids = selectedIssues.map(issue => issue.id);
        const ids = [];
        //calculate payload start
        let projectIds = [];
        let issueIds = [];
        selectedProjectIssues.map(singleProject => {
          const projectSelectedIssues = singleProject.issuesSelected;
          if (
            isValidArray(projectSelectedIssues) &&
            projectSelectedIssues.length > 0
          ) {
            //loop through issues
            projectSelectedIssues.map(issue => {
              issueIds.push(issue.id);
            });
          } else {
            //Add project id in array
            projectIds.push(singleProject.id);
          }
        });
        const params = {
          projectIds,
          issueIds
        };
        //calculate payload end
        guestListDispatch(undefined, params).then(resp => {
          resp && this.filterGuestList(resp.data, selectedGuests);
        });
      }
    );
  };

  deselectIssues = (idx, id) => {
    this.setState(
      prevState => {
        //let updatedSelectedProjectIssues = [];
        const updatedSelectedProjectIssues = prevState.selectedProjectIssues.map(
          singleProject => {
            return {
              ...singleProject,
              issuesSelected: singleProject.issuesSelected.filter(
                item => item.id !== idx
              )
            };
          }
        );
        let updatedSelectedIssues = [];
        updatedSelectedIssues = updatedSelectedProjectIssues.reduce(
          (acc, singleProject) => {
            return acc.concat(singleProject.issuesSelected);
          },
          []
        );

        return {
          // deletedProjects: deletedProject,
          selectedProjectIssues: updatedSelectedProjectIssues,
          selectedIssues: updatedSelectedIssues,
          dataUnsaved: true
        };
      },
      () => {
        const {
          selectedIssues,
          selectedProjectIssues,
          selectedGuests
        } = this.state;
        //console.log(selectedIssues);
        const { guestListDispatch } = this.props;
        // const ids = selectedIssues.map(issue => issue.id);
        //calculate payload start
        let projectIds = [];
        let issueIds = [];
        selectedProjectIssues.map(singleProject => {
          const projectSelectedIssues = singleProject.issuesSelected;
          if (
            isValidArray(projectSelectedIssues) &&
            projectSelectedIssues.length > 0
          ) {
            //loop through issues
            projectSelectedIssues.map(issue => {
              issueIds.push(issue.id);
            });
          } else {
            //Add project id in array
            projectIds.push(singleProject.id);
          }
        });
        const params = {
          projectIds,
          issueIds
        };
        //calculate payload end
        const ids = [];
        guestListDispatch(undefined, params).then(resp => {
          resp && this.filterGuestList(resp.data, selectedGuests);
        });
      }
    );
  };

  changeFromDateTime = (meetingDate, meetingTimeFrom) => {
    const meetingTime = new Date(meetingTimeFrom);
    const year = meetingDate.getFullYear();
    const month = meetingDate.getMonth();
    const day = meetingDate.getDate();
    meetingTime.setFullYear(year);
    meetingTime.setMonth(month);
    meetingTime.setDate(day);
    return meetingTime;
  };

  changeToDateTime = (meetingDate, meetingTimeTo) => {
    const meetingTime = new Date(meetingTimeTo);
    const year = meetingDate.getFullYear();
    const month = meetingDate.getMonth();
    const day = meetingDate.getDate();
    meetingTime.setFullYear(year);
    meetingTime.setMonth(month);
    meetingTime.setDate(day);
    return meetingTime;
  };

  submitAgenda = async () => {
    const {
      createMom,
      history,
      updateMom,
      getUpcommingAgendaFlagDispatch
    } = this.props;
    const {
      formData,
      selectedGuests,
      fileDto,
      removeFileClicked,
      finalOrderedList,
      selectedIssues,
      selectedProjectIssues,
      originalGuestLists
    } = this.state;
    if (finalOrderedList && finalOrderedList.length === 0) {
      let projectIdList =
        selectedIssues && selectedIssues.length > 1
          ? this.getSelectedProjectIdList(selectedProjectIssues)
          : [];
      formData.projectOrder = projectIdList.map(project => project.id);
    } else {
      formData.projectOrder = (finalOrderedList || []).map(
        project => project.id
      );
    }
    const meetingTiming =
      formData.meetingTimeFrom === 0 ||
      formData.meetingTimeFrom === null ||
      formData.meetingTimeFrom === ""
        ? ""
        : this.changeFromDateTime(
            formData.meetingDate,
            formData.meetingTimeFrom
          );
    const meetingToTiming =
      formData.meetingTimeTo === 0 ||
      formData.meetingTimeTo === null ||
      formData.meetingTimeTo === ""
        ? ""
        : this.changeToDateTime(formData.meetingDate, formData.meetingTimeTo);
    formData.issues = (this.state.selectedIssues || []).map(issue => issue.id);
    formData.projects = (this.state.selectedProjectIssues || []).map(
      project => project.id
    );
    formData.meetingStatus = "SCHEDULED";
    formData.meetingTimeFrom =
      formData.meetingTimeFrom === 0 ||
      formData.meetingTimeFrom === null ||
      formData.meetingTimeFrom === ""
        ? meetingTiming
        : meetingTiming.getTime();
    formData.meetingTimeTo =
      formData.meetingTimeTo === 0 ||
      formData.meetingTimeTo === null ||
      formData.meetingTimeTo === ""
        ? meetingToTiming
        : meetingToTiming.getTime();
    formData.guests = [];
    formData.users = [];
    formData.meetingMode = formData.meetingMode ? formData.meetingMode : null;
    if (fileDto) formData.fileAttachment = fileDto.id;
    if (
      formData &&
      formData.fileDTOList &&
      formData.fileDTOList.length &&
      !fileDto &&
      !removeFileClicked
    ) {
      const files = formData.fileDTOList.map(value => value.id);
      formData.fileAttachment = files && files[0];
    }
    const user = getLocalstorage("user");
    const isAgendauser =
      get(user, "groupCategory") == "CENTRAL" ||
      get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
      get(user, "groupCategory") == "STATE";
    if (isValidArray(selectedGuests)) {
      this.setState({ showLoader: true });

      const originalArray = originalGuestLists
        .filter(item => {
          return selectedGuests.some(bItem => bItem.userId === item.userId);
        })
        .map(item => {
          const bItem = selectedGuests.find(
            bItem => bItem.userId === item.userId
          );
          return { ...item, emailType: bItem.emailType };
        })
        .concat(selectedGuests.filter(item => item.userAddedGuest === true));

      const updatedSelectedGuests = originalArray.map(item => {
        if (item.guestCategory === "PMG") {
          return { ...item, emailType: "CC" };
        }
        return item;
      });

      (updatedSelectedGuests || []).forEach(value => {
        value.userId
          ? formData.users.push({
              userId: value.userId,
              emailType: value.emailType,
              email: value.email,
              guestCategory: value.guestCategory,
              groupId: value.groupId
            })
          : formData.guests.push({
              email: value.userName,
              emailType: value.emailType,
              guestCategory: value.guestCategory,
              groupId: value.groupId
            });
      });
      let response = null;
      const formDataAgendaName = htmlToFormattedText(formData.agendaName);
      const formDataMeetingChairedBy = htmlToFormattedText(
        formData.meetingChairedBy
      );
      formData.agendaName = formDataAgendaName;
      formData.meetingChairedBy = formDataMeetingChairedBy;
      if (formData && formData.id) {
        this.setState({ showLoader: true });
        response = await updateMom(undefined, formData);
      } else {
        response = await createMom(undefined, formData);
      }
      if (response) {
        this.setState({ showLoader: false });
        const { message, status, error } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          history.push(PATHS.AGENDA_LIST);
          //write logic to update upcomming scheduled pragati agenda flag here
          getUpcommingAgendaFlagDispatch();
        } else {
          toast.error(
            <p className="toast-text-alignment">{message || error}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } else if (isAgendauser) {
      this.setState({ showLoader: true });
      let response = null;
      const formDataAgendaName = htmlToFormattedText(formData.agendaName);
      const formDataMeetingChairedBy = htmlToFormattedText(
        formData.meetingChairedBy
      );
      formData.agendaName = formDataAgendaName;
      formData.meetingChairedBy = formDataMeetingChairedBy;
      if (formData && formData.id) {
        this.setState({ showLoader: true });
        response = await updateMom(undefined, formData);
      } else {
        response = await createMom(undefined, formData);
      }
      if (response) {
        this.setState({ showLoader: false });
        const { message, status, error } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          history.push(PATHS.AGENDA_LIST);
          //write logic to update upcomming scheduled pragati agenda flag here
          getUpcommingAgendaFlagDispatch();
        } else {
          toast.error(
            <p className="toast-text-alignment">{message || error}</p>,
            errorToastStyle
          );
        }
      }
    } else
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.SELECT_GUEST}</p>,
        errorToastStyle
      );
  };

  saveAsDraft = async (shouldRedirect = true) => {
    this.setState({ showLoader: true });
    const { createMom, history, updateMom, location } = this.props;
    const {
      formData,
      selectedGuests,
      fileDto,
      removeFileClicked,
      finalOrderedList,
      selectedIssues,
      selectedProjectIssues
    } = this.state;
    if (finalOrderedList && finalOrderedList.length === 0) {
      let projectIdList =
        selectedIssues && selectedIssues.length > 1
          ? this.getSelectedProjectIdList(selectedProjectIssues)
          : [];
      formData.projectOrder = projectIdList.map(project => project.id);
    } else {
      formData.projectOrder = (finalOrderedList || []).map(
        project => project.id
      );
    }
    formData.meetingType =
      formData.meetingType === "" ? null : formData.meetingType;
    const meetingTiming =
      formData.meetingTimeFrom === 0 ||
      formData.meetingTimeFrom === null ||
      formData.meetingTimeFrom === ""
        ? ""
        : this.changeFromDateTime(
            formData.meetingDate,
            formData.meetingTimeFrom
          );
    const meetingToTiming =
      formData.meetingTimeTo === 0 ||
      formData.meetingTimeTo === null ||
      formData.meetingTimeTo === ""
        ? ""
        : this.changeToDateTime(formData.meetingDate, formData.meetingTimeTo);

    formData.issues = (this.state.selectedIssues || []).map(issue => issue.id);
    formData.projects = (this.state.selectedProjectIssues || []).map(
      project => project.id
    );
    formData.meetingTimeFrom =
      formData.meetingTimeFrom !== 0 &&
      formData.meetingTimeFrom !== null &&
      formData.meetingTimeFrom !== ""
        ? meetingTiming.getTime()
        : null;
    formData.meetingTimeTo =
      formData.meetingTimeTo !== 0 &&
      formData.meetingTimeTo !== null &&
      formData.meetingTimeTo !== ""
        ? meetingToTiming.getTime()
        : null;
    formData.meetingStatus = "DRAFT";
    formData.guests = [];
    formData.users = [];
    formData.meetingMode = formData.meetingMode ? formData.meetingMode : null;
    if (fileDto) formData.fileAttachment = fileDto.id;
    if (
      formData &&
      formData.fileDTOList &&
      formData.fileDTOList.length &&
      !fileDto &&
      !removeFileClicked
    ) {
      const files = formData.fileDTOList.map(value => value.id);
      formData.fileAttachment = files && files[0];
    }
    (selectedGuests || []).forEach(value => {
      value.userId
        ? formData.users.push({
            userId: value.userId,
            emailType: value.emailType,
            email: value.email,
            guestCategory: value.guestCategory,
            groupId: value.groupId
          })
        : formData.guests.push({
            emailType: value.emailType,
            email: value.email,
            guestCategory: value.guestCategory,
            groupId: value.groupId
          });
    });
    let response = null;
    if (formData && formData.id && !formData.parentId) {
      response = await updateMom(undefined, formData);
    } else {
      response = await createMom(undefined, formData);
    }
    if (response) {
      this.setState({ showLoader: false });
      if (shouldRedirect) {
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          history.push(PATHS.AGENDA_LIST);
        } else {
          toast.error(
            <p className="toast-text-alignment">
              {message || ERROR_MSG.INVALID_FORM}
            </p>,
            errorToastStyle
          );
        }
      } else {
        const { data } = response;
        let _id = data
          ? data
          : location &&
            location.state &&
            location.state.agendaId &&
            get(location, "state.agendaId");
        this.handleEditAgenda(_id);
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  saveAsDraftValidator = callback => {
    const {
      error,
      formData: { agendaName },
      selectedGuests
    } = this.state;
    let guestWithToEmailArray =
      selectedGuests &&
      selectedGuests.length &&
      selectedGuests.filter(item => item.emailType === "TO");
    if (!error.agendaName || get(error, "agendaName.error")) {
      this.setState({
        error: {
          agendaName: {
            error: !agendaName,
            message: !agendaName && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    } else {
      typeof callback === "function" && callback();
    }
  };

  onChange = (key, value) => {
    const { formData } = this.state;
    console.log(key, value, formData);
    this.setState({
      formData: {
        ...formData,
        [key]: value
      },
      dataUnsaved: true
    });
  };

  onError = (key, value) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  validateError = callback => {
    const {
      error,
      formData: {
        agendaName,
        venue,
        meetingChairedBy,
        meetingMode,
        meetingType,
        meetingTimeFrom
      },
      selectedGuests
    } = this.state;
    let guestWithToEmailArray =
      selectedGuests &&
      selectedGuests.length &&
      selectedGuests.filter(item => item.emailType === "TO");
    if (
      !error.agendaName ||
      get(error, "agendaName.error") ||
      (!error.venue || get(error, "venue.error")) ||
      (!error.meetingChairedBy || get(error, "meetingChairedBy.error")) ||
      !meetingType ||
      !meetingTimeFrom
    ) {
      this.setState({
        error: {
          agendaName: {
            error: !agendaName,
            message: !agendaName && ERROR_MSG.DEFAULT_MSG
          },
          venue: {
            error: !venue,
            message: !venue && ERROR_MSG.DEFAULT_MSG
          },
          meetingMode: {
            error: !meetingMode,
            message: !meetingMode && ERROR_MSG.DEFAULT_MSG
          },
          meetingChairedBy: {
            error: !meetingChairedBy,
            message: !meetingChairedBy && ERROR_MSG.DEFAULT_MSG
          },
          meetingType: {
            error: !meetingType,
            message: !meetingType && ERROR_MSG.DEFAULT_MSG
          },
          meetingTimeFrom: {
            error: !meetingTimeFrom,
            message: !meetingTimeFrom && ERROR_MSG.DEFAULT_MSG
          }
        }
      });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    } else {
      typeof callback === "function" && callback();
    }
  };

  validateField = (fieldName, value) => {
    const { error } = this.state;
    switch (fieldName) {
      case "meetingChairedBy":
        this.setState({
          error: {
            ...error,
            meetingChairedBy: value
          }
        });
        break;
      default:
        break;
    }
  };

  updatedSelectedGuest = (value, key) => {
    this.setState({
      [key]: value,
      dataUnsaved: true
    });
  };

  originalGuestList = data => {
    this.setState({
      originalGuestLists: data
    });
  };

  removeDuplicateGuests = guestList => {
    const uniqueIds = new Set();
    const filteredList = [];

    guestList &&
      guestList.forEach(guest => {
        if (guest.userId) {
          if (!uniqueIds.has(guest.userId)) {
            uniqueIds.add(guest.userId);
            filteredList.push(guest);
          }
        } else {
          filteredList.push(guest);
        }
      });

    return filteredList;
  };

  deleteGuests = userId => {
    this.setState(prevState => {
      prevState.selectedGuests = Array.isArray(prevState.selectedGuests)
        ? prevState.selectedGuests
        : [];
      const uniqueGuestList = this.removeDuplicateGuests(
        prevState.selectedGuests
      );
      const index = uniqueGuestList.findIndex(guest => guest.userId === userId);
      if (index !== -1) {
        uniqueGuestList.splice(index, 1);
      }

      return {
        selectedGuests: uniqueGuestList
      };
    });
  };

  deleteAgenda = async () => {
    const { formData } = this.state;
    const { history } = this.props;
    if (formData && formData.id) {
      this.setState({ showLoader: true });
      let response = await deleteMOM(undefined, formData);
      if (response) {
        this.setState({ showLoader: false });
        const { message, status } = response;
        if (status) {
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          history.push(PATHS.AGENDA_LIST);
        } else {
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    }
  };

  handleDropdownSelect = value => {
    this.setState({ selectedValue: value });
    if (this.state.selectedValue.title === "With Issue Status") {
      const { isPPTChecked } = this.state;
      this.setState({
        isPPTChecked: !isPPTChecked
      });
    }
  };

  handleDownloadLinkClick = () => {
    this.setState({ selectedValue: "" });
  };

  onToggleAttachment = fileId => {
    this.setState({
      toggleAttachementDisplay: !this.state.toggleAttachementDisplay
    });
  };

  onToggleUpload = fileId => {
    this.setState({
      //toggleUploadDisplay: !this.state.toggleUploadDisplay,
      toggleUploadDisplay: false
    });
  };

  closeUploadPopup = () => {
    this.setState({ toggleUploadDisplay: false });
  };

  openUploadPopup = isCustom => {
    this.setState({
      toggleUploadDisplay: true,
      isCustom: isCustom
    });
  };

  browseUploadPopup = () => {
    this.setState({ toggleBrowseDisplay: true });
  };
  closeBrowseUploadPopup = () => {
    this.setState({ toggleBrowseDisplay: false });
  };

  onRemoveFile = ({ id }) => {
    try {
      this.setState({
        addAttchementRequired: !this.state.addAttchementRequired,
        fileDto: null,
        removeFileClicked: true
      });
    } catch (error) {}
  };

  onSuccessUploadOfAttachmets = async fileDto => {
    try {
      this.onToggleAttachment();
      this.setState({
        addAttchementRequired: false,
        fileDto: fileDto,
        dataUnsaved: true
      });
    } catch (error) {
      console.error(error.message);
    }
  };

  getIssueCountById = (selectedIssues, projectId) => {
    let IssueWithCommonProjectId =
      selectedIssues &&
      selectedIssues.length &&
      selectedIssues.filter(issue => {
        return issue.project && issue.project.id === projectId;
      });

    return IssueWithCommonProjectId && IssueWithCommonProjectId.length;
  };

  getIssueCount = (selectedProjectIssues, projectId) => {
    const selectedProject = selectedProjectIssues.find(
      project => project.projectId === projectId
    );
    const length = get(selectedProject, "issuesSelected", []).length;

    return length;
  };

  getSelectedProjectIdList = (selectedProjectIssues, category = null) => {
    let arr = [];
    //console.log("selectedProjectIssues", selectedProjectIssues);
    selectedProjectIssues.forEach(item => {
      //console.log(item);
      let pragatiReview = get(item, "pragatiDTO").pragatiReview;
      item.pragatiReview = pragatiReview;
      let totalCost = item.cost;
      item.totalCost = totalCost;
      let projectCategory = item.category;
      item.issueCount = get(item, "issuesSelected", []).length;

      if (
        !arr.find(({ id }) => id === item.id) &&
        (category === null || (category && projectCategory === category))
      ) {
        arr.push(item);
      }
    });

    //console.log(arr);
    return arr;
  };
  getProjectIdList = (selectedIssues, category = null) => {
    let arr = [];

    selectedIssues.map(item => {
      let projectId = item.project && item.project.id;
      let projectName = item.project && item.project.name;
      let displayId = item.project && item.project.displayId;
      let pragatiReview = item.project && item.project.pragatiReview;
      let totalCost = item.project && item.project.totalCost;
      let projectSector = item.project && item.project.projectSector;
      let projectCategory = item.project && item.project.projectCategory;

      if (
        !arr.find(({ id }) => id === projectId) &&
        (category === null || (category && projectCategory === category))
      ) {
        arr.push({
          id: projectId,
          name: projectName,
          displayId: displayId,
          pragatiReview: pragatiReview,
          totalCost: totalCost,
          projectCategory,
          projectSector,
          issueCount: this.getIssueCountById(selectedIssues, projectId)
        });
      }
    });

    return arr;
  };

  onToggleSelectOrdering = () => {
    this.setState({
      showSelectOrderingModal: !this.state.showSelectOrderingModal
    });
  };

  setFinalOrderingForState = list => {
    this.setState({
      _orderedListForState: list
    });
  };

  setFinalOrderingForCentral = list => {
    this.setState({
      _orderedListForCentral: list
    });
  };

  onApplyOrder = list => {
    let {
      _orderedListForState = [],
      _orderedListForCentral = [],
      selectedIssues,
      selectedProjectIssues
    } = this.state;
    const groupCategory = getLocalstorage("groupCategory");
    // let centralProjectIdList =
    //   selectedIssues && selectedIssues.length > 1
    //     ? this.getProjectIdList(selectedIssues, "CENTRAL")
    //     : null;

    // let stateProjectIdList =
    //   selectedIssues && selectedIssues.length > 1
    //     ? this.getProjectIdList(selectedIssues, "STATE")
    //     : null;

    let centralProjectIdList =
      selectedProjectIssues && selectedProjectIssues.length > 1
        ? this.getSelectedProjectIdList(selectedProjectIssues, "CENTRAL")
        : null;

    let stateProjectIdList =
      selectedProjectIssues && selectedProjectIssues.length > 1
        ? this.getSelectedProjectIdList(selectedProjectIssues, "STATE")
        : null;

    let centralList =
      _orderedListForCentral && _orderedListForCentral.length
        ? _orderedListForCentral
        : centralProjectIdList && centralProjectIdList.length
        ? centralProjectIdList
        : [];

    let stateList =
      _orderedListForState && _orderedListForState.length
        ? _orderedListForState
        : stateProjectIdList && stateProjectIdList.length
        ? stateProjectIdList
        : [];

    this.setState(
      {
        finalOrderedList:
          groupCategory === "STATE_PMG" || groupCategory === "STATE"
            ? [...stateList, ...centralList]
            : [...centralList, ...stateList]
      },
      () => {
        this.setState(
          { dataUnsaved: false },
          this.saveAsDraftValidator.bind(this, () => this.saveAsDraft(false))
        );
      }
    );
  };
  getAgendaStackeHolder = async () => {
    const { agendaId } = this.state;
    return await getAgendaStakeHolderAction(undefined, agendaId);
  };

  getPermissionSingletonObject = () => {
    const { permissionsListing } = this.props;
    if (
      !this.permissions &&
      get(permissionsListing, "status") &&
      isValidArray(get(permissionsListing, "data"))
    ) {
      this.permissionsListing = PERMISSIONS_BY_MODULE(
        get(permissionsListing, "data")
      );
    }
    return this.permissionsListing;
  };

  onPPTChecked = () => {
    const { isPPTChecked } = this.state;
    this.setState({
      isPPTChecked: !isPPTChecked
    });
  };

  closeUploadedListModal = () => {
    this.setState({ showUploadedResultModal: false });
  };

  closeUploadErrorModal = () => {
    this.setState({ showUploadErrorModal: false });
  };

  render() {
    const user = getLocalstorage("user");
    const {
      pageInfo,
      history,
      agendaMeetingPptv2,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      agendaMeetingPpt,
      downloadAgendaMeetingPpt,
      clearDownloadAgendaMeetingPptAction,
      agendaMeetingExcel,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction,
      clearDownloadAgendaMeetingCabSecPptAction,
      agendaMeetingPptv2WithoutIssue,
      permissionsListing,
      downloadAgendaCabSecPpt,
      agendaMeetingCabSecPpt,
      downloadAgendaMeetingPptv2PragatiFormat,
      clearDownloadAgendaMeetingPptv2PragatiFormatAction,
      agendaMeetingPptv2PragatiFormat,
      uploadAgendaTmp,
      clearDownloadUpdaloadAgendaTemplateAction,
      downloadUpdaloadAgendaTemplateAction
    } = this.props;
    let {
      isAddIssueModalVisible,
      isAddProjectModalVisible,
      formData,
      selectedIssues,
      selectedProjectIssues,
      selectedProjects,
      selectedGuests,
      title,
      error,
      showLoader,
      agendaId,
      deletedIssued,
      deletedProjects,
      toggleAttachementDisplay,
      toggleUploadDisplay,
      toggleBrowseDisplay,
      addAttchementRequired,
      fileDto,
      removeFileClicked,
      dataUnsaved,
      showSelectOrderingModal,
      finalOrderedList,
      isUsePresetCheckedForCentral,
      isPresetChecked,
      agendaMeetingTypeDetails,
      isPPTChecked,
      listofFiles,
      showUploadedResultModal,
      isCustom,
      showUploadErrorModal
    } = this.state;
    const agendaStatus = formData.meetingStatus;
    let fileArr =
      formData.fileDTOList &&
      isValidArray(formData.fileDTOList) &&
      !removeFileClicked
        ? formData.fileDTOList
        : [fileDto];

    // let projectIdList =
    //   selectedIssues && selectedIssues.length > 1
    //     ? this.getProjectIdList(selectedIssues)
    //     : null;

    let projectIdList =
      selectedProjectIssues && selectedProjectIssues.length > 1
        ? this.getSelectedProjectIdList(selectedProjectIssues)
        : null;

    // let centralProjectIdList =
    //   selectedIssues && selectedIssues.length > 1
    //     ? this.getProjectIdList(selectedIssues, "CENTRAL")
    //     : null;
    let centralProjectIdList =
      selectedProjectIssues && selectedProjectIssues.length > 1
        ? this.getSelectedProjectIdList(selectedProjectIssues, "CENTRAL")
        : null;

    // let stateProjectIdList =
    //   selectedIssues && selectedIssues.length > 1
    //     ? this.getProjectIdList(selectedIssues, "STATE")
    //     : null;

    let stateProjectIdList =
      selectedProjectIssues && selectedProjectIssues.length > 1
        ? this.getSelectedProjectIdList(selectedProjectIssues, "STATE")
        : null;
    //console.log("stateProjectIdList", stateProjectIdList);

    let permission = this.getPermissionSingletonObject();

    const downloadTemplateBlock = (
      <div className="download-section">
        <hr />
        <div className="add-issue-subdesc-downld">
          Download Template:
          <div
            className="download-excel-component upload-agenda"
            style={{ border: "none" }}
          >
            <DownloadExcelReport
              isLoading={uploadAgendaTmp && uploadAgendaTmp.isLoading}
              downloadLink={uploadAgendaTmp && uploadAgendaTmp.downloadingSrc}
              onClearDownload={clearDownloadUpdaloadAgendaTemplateAction}
              onStartDownloading={downloadUpdaloadAgendaTemplateAction}
            />
          </div>
        </div>
      </div>
    );

    return (
      <React.Fragment>
        <LoaderPage loading={showLoader} />
        <Prompt
          when={dataUnsaved}
          message={location => {
            return location.pathname === history.location.pathname
              ? true
              : "You have unsaved changes, are you sure you want to leave?";
          }}
        />
        <div className="content no-sidebar page-create-agenda">
          <div className="container">
            <div className="page-heading-wrapper">
              <h1 className="page-heading">{title} Agenda</h1>
              <div className="today-date">
                Calendar
                <span>{moment(new Date()).format("LL")}</span>
              </div>
            </div>
            <CreateAgendaForm
              venues={pageInfo && pageInfo.venueList}
              meetingModesOptions={pageInfo && pageInfo.meetingModes}
              agendaSenders={pageInfo && pageInfo.agentSentFromList}
              formData={formData}
              onChange={this.onChange}
              onError={this.onError}
              error={error}
              validateField={this.validateField}
              agendaMeetingTypeDetails={agendaMeetingTypeDetails}
            />
            <div className="agenda-details-issues agenda-detail-attach-documents">
              <h3 className="agenda-issues-heading">Attach OM</h3>
              <DisplayAttachments
                isAgendaAttachment={true}
                onTogglePopUp={this.onToggleAttachment}
                filesArr={fileArr}
                onRemoveFile={this.onRemoveFile}
                addAttchementRequired={addAttchementRequired}
                agendadetailcss={true}
              />
              {toggleAttachementDisplay ? (
                <UploadAttachmentsWithTitleComponent
                  displayModal={toggleAttachementDisplay}
                  onCloseModal={this.onToggleAttachment}
                  //fileFormats={DOCUMENT_FORMATS_AGENDA}
                  fileFormats={DOCUMENT_FORMATS}
                  onSubmit={this.onSuccessUploadOfAttachmets}
                  forFileSize={true}
                />
              ) : null}
            </div>
            {get(formData, "meetingCreatedBy") ? (
              <div className="agenda-created-on space-bottom">
                Agenda Created by{" "}
                <span>{get(formData, "meetingCreatedBy", null)}</span> on{" "}
                <span>
                  {dateFormatWithTime(get(formData, "agendaCreatedOn", null))}
                </span>
              </div>
            ) : null}
            <DisplayByPermission display={isAddProjectModalVisible}>
              <SelectProject
                show={isAddProjectModalVisible}
                closeModal={this.closeAddProjectModal}
                selectedProjects={selectedProjectIssues}
                //closeIssueModal={this.closeAddIssueModal}
                selectedIssues={selectedIssues}
                submitHandler={this.addProjectIssuesToAgenda}
                deletedProjects={deletedProjects}
                //resetSelectedIssues={this.resetSelectedIssues}
              />
            </DisplayByPermission>
            <div className="add-issue-link-wrapper">
              {isValidArray(selectedProjectIssues) ? (
                <h2 className="page-orange-bar">
                  Projects{" "}
                  {isValidArray(selectedProjectIssues) ? (
                    <span>({selectedProjectIssues.length})</span>
                  ) : (
                    <span>(0)</span>
                  )}{" "}
                  & Issues{" "}
                  {isValidArray(selectedIssues) ? (
                    <span>({selectedIssues.length})</span>
                  ) : (
                    <span>(0)</span>
                  )}
                </h2>
              ) : (
                <h2 className="page-orange-bar">Add Projects & Issues </h2>
              )}

              <div className="addissue-heading-wrapper-draft">
                <div className="page-orange-bar-right">
                  {agendaId ? (
                    <div className="agenda-issues-button-wrapper">
                      {get(user, "groupCategory") === "PMG" && (
                        <div className="agenda-ppt-v3">
                          <AgendaDropdown
                            customStyle={true}
                            selected={
                              this.state.selectedValue
                                ? this.state.selectedValue
                                : { title: "Select PPT" }
                            }
                            options={DROP_DOWN_VALUES}
                            onSelect={value => this.handleDropdownSelect(value)}
                            isDraft={true}
                          />
                          {!this.state.selectedValue ||
                          this.state.selectedValue.title === "" ? (
                            <div className="disabled-ppt1">
                              <img
                                sizes="10px"
                                src={DisabledPPt}
                                variant="outline-info"
                              />
                            </div>
                          ) : this.state.selectedValue.title ===
                            "Monitoring Group" ? (
                            <div
                              className={
                                get(user, "groupCategory") === "PMG"
                                  ? "agenda-ppt-v3"
                                  : ""
                              }
                            >
                              <DownloadExcelReport
                                border={true}
                                isLoading={
                                  agendaMeetingPpt && agendaMeetingPpt.isLoading
                                }
                                downloadLink={
                                  agendaMeetingPpt &&
                                  agendaMeetingPpt.downloadingSrc
                                }
                                onClearDownload={() =>
                                  clearDownloadAgendaMeetingPptAction()
                                }
                                onStartDownloading={() =>
                                  downloadAgendaMeetingPpt(agendaId)
                                }
                                onDownloadLinkClick={
                                  this.handleDownloadLinkClick
                                }
                                iconClassName="ppt-icon"
                                isDraft={true}
                                isPMG={true}
                              />
                            </div>
                          ) : this.state.selectedValue.title ===
                            "With issue status" ? (
                            <>
                              <DownloadExcelReport
                                border={true}
                                isLoading={
                                  agendaMeetingPptv2 &&
                                  agendaMeetingPptv2.isLoading
                                }
                                downloadLink={
                                  agendaMeetingPptv2 &&
                                  agendaMeetingPptv2.downloadingSrc
                                }
                                onClearDownload={
                                  clearDownloadAgendaMeetingPptv2Action
                                }
                                onStartDownloading={() =>
                                  downloadAgendaMeetingPptv2(
                                    agendaId,
                                    false,
                                    true
                                  )
                                }
                                onDownloadLinkClick={
                                  this.handleDownloadLinkClick
                                }
                                iconClassName="ppt-icon"
                                isDraft={true}
                                isPMG={true}
                              />
                            </>
                          ) : this.state.selectedValue.title ===
                            "Without issue status" ? (
                            <>
                              <div>
                                <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPptv2WithoutIssue &&
                                    agendaMeetingPptv2WithoutIssue.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPptv2WithoutIssue &&
                                    agendaMeetingPptv2WithoutIssue.downloadingSrc
                                  }
                                  onClearDownload={() =>
                                    clearDownloadAgendaMeetingPptv2WithoutIssueAction()
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPptv2(
                                      agendaId,
                                      false,
                                      false
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                  isPMG={true}
                                />
                              </div>
                            </>
                          ) : this.state.selectedValue.title ===
                            "PRAGATI Format" ? (
                            <>
                              <div>
                                <DownloadExcelReport
                                  border={true}
                                  isLoading={
                                    agendaMeetingPptv2PragatiFormat &&
                                    agendaMeetingPptv2PragatiFormat.isLoading
                                  }
                                  downloadLink={
                                    agendaMeetingPptv2PragatiFormat &&
                                    agendaMeetingPptv2PragatiFormat.downloadingSrc
                                  }
                                  onClearDownload={() =>
                                    clearDownloadAgendaMeetingPptv2PragatiFormatAction()
                                  }
                                  onStartDownloading={() =>
                                    downloadAgendaMeetingPptv2PragatiFormat(
                                      agendaId
                                    )
                                  }
                                  onDownloadLinkClick={
                                    this.handleDownloadLinkClick
                                  }
                                  iconClassName="ppt-icon"
                                  isDraft={true}
                                  isPMG={true}
                                />
                              </div>
                            </>
                          ) : this.state.selectedValue.title ===
                            "CabSec format" ? (
                            <>
                              <DownloadExcelReport
                                border={true}
                                isLoading={
                                  agendaMeetingCabSecPpt &&
                                  agendaMeetingCabSecPpt.isLoading
                                }
                                downloadLink={
                                  agendaMeetingCabSecPpt &&
                                  agendaMeetingCabSecPpt.downloadingSrc
                                }
                                onClearDownload={
                                  clearDownloadAgendaMeetingCabSecPptAction
                                }
                                onStartDownloading={() =>
                                  downloadAgendaCabSecPpt(agendaId)
                                }
                                onDownloadLinkClick={
                                  this.handleDownloadLinkClick
                                }
                                iconClassName="ppt-icon"
                                isDraft={true}
                                isPMG={true}
                              />
                            </>
                          ) : null}
                        </div>
                      )}
                      {get(user, "groupCategory") !== "PMG" && (
                        <div>
                          <DownloadExcelReport
                            // isLoading={
                            //   agendaMeetingPpt && agendaMeetingPpt.isLoading
                            // }
                            // downloadLink={
                            //   agendaMeetingPpt &&
                            //   agendaMeetingPpt.downloadingSrc
                            // }
                            // onClearDownload={() =>
                            //   clearDownloadAgendaMeetingPptAction()
                            // }
                            // onStartDownloading={() =>
                            //   downloadAgendaMeetingPpt(agendaId)
                            // }
                            // onDownloadLinkClick={this.handleDownloadLinkClick}
                            isLoading={
                              agendaMeetingPptv2 && agendaMeetingPptv2.isLoading
                            }
                            downloadLink={
                              agendaMeetingPptv2 &&
                              agendaMeetingPptv2.downloadingSrc
                            }
                            onClearDownload={
                              clearDownloadAgendaMeetingPptv2Action
                            }
                            onStartDownloading={() =>
                              downloadAgendaMeetingPptv2(agendaId, false, true)
                            }
                            onDownloadLinkClick={this.handleDownloadLinkClick}
                            iconClassName="ppt-icon"
                            isDraft={true}
                            isPMG={false}
                          />
                        </div>
                      )}
                      <div className="agenda-meeting-excel">
                        <DownloadExcelReportAgenda
                          isLoading={
                            agendaMeetingExcel && agendaMeetingExcel.isLoading
                          }
                          downloadLink={
                            agendaMeetingExcel &&
                            agendaMeetingExcel.downloadingSrc
                          }
                          onClearDownload={() =>
                            clearDownloadAgendaMeetingExcelAction()
                          }
                          onStartDownloading={() =>
                            downloadAgendaMeetingExcel(agendaId)
                          }
                          isDraft={true}
                        />
                      </div>
                      <div className="agenda-meeting-doc">
                        {/* <DownloadExcelReport
                            isLoading={
                              agendaMeetingPpt && agendaMeetingPpt.isLoading
                            }
                            downloadLink={
                              agendaMeetingPpt &&
                              agendaMeetingPpt.downloadingSrc
                            }
                            onClearDownload={() =>
                              clearDownloadAgendaMeetingPptAction()
                            }
                            onStartDownloading={() =>
                              downloadAgendaMeetingPpt(agendaId)
                            }
                            onDownloadLinkClick={this.handleDownloadLinkClick}
                            iconClassName="doc-icon"
                            isDraft={true}
                          /> */}
                        {agendaId ? (
                          <DownloadAgendaByType id={agendaId} />
                        ) : null}
                      </div>
                    </div>
                  ) : null}
                  {agendaId &&
                    (get(user, "groupCategory") == "PMG" ||
                      get(user, "groupCategory") == "STATE_PMG") && (
                      <DownloadAgendaParticipants
                        id={agendaId}
                        isDraft={true}
                      />
                    )}
                  {(agendaId &&
                    (centralProjectIdList &&
                      centralProjectIdList.length > 1)) ||
                  (agendaId &&
                    (stateProjectIdList && stateProjectIdList.length > 1)) ? (
                    <button
                      className="set-order-btn1"
                      onClick={this.onToggleSelectOrdering}
                    >
                      <span className="set-order">SET ORDER</span>
                    </button>
                  ) : null}
                  {agendaId &&
                    (get(user, "groupCategory") === "PMG" ||
                      get(user, "groupCategory") === "STATE_PMG") && (
                      <DisplayByPermission
                        display={!get(permission, "canViewOnlyProject")}
                      >
                        <SendByComponent1
                          containerClass="send_notification agenda-details-compose-button"
                          getStakeHolders={this.getAgendaStackeHolder}
                          notificationCO={{ draftDetails: {} }}
                          customNotificationType="AGENDA"
                          style={"pr-4"}
                          meetingId={agendaId}
                          isDraft={true}
                        />
                      </DisplayByPermission>
                    )}
                  {isValidArray(selectedProjectIssues) ? (
                    // <Button
                    //   className="btn-blue-invert no-padding1"
                    //   onClick={this.showAddProjectModal}
                    // >
                    //   <span>+</span> Add Project(s) & Issue(s)
                    // </Button>
                    <Dropdown>
                      <Dropdown.Toggle
                        as={Button}
                        bsPrefix="btn-blue-invert no-padding1"
                        id="add-project-dropdown"
                      >
                        <span>+</span> Add Project(s) & Issue(s)
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          className="agenda-custom-color"
                          onClick={this.showAddProjectModal}
                          style={{ fontSize: 15, fontFamily: "mpsb" }}
                        >
                          Add Manually
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="agenda-custom-color"
                          //onClick={this.browseUploadPopup}
                          onClick={() => this.openUploadPopup(true)}
                          style={{ fontSize: 15, fontFamily: "mpsb" }}
                        >
                          Upload Excel File
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : null}
                </div>
              </div>
              {!isValidArray(selectedProjectIssues) ? (
                // <div
                //   className="add-issue-for-meeting"
                //   onClick={this.showAddProjectModal}
                // >
                //   <div className="add-issue-link">
                //     <span>+</span>Add Project(s)
                //   </div>
                //   <div className="add-issue-desc">
                //     Issues can be added after selecting the Projects
                //   </div>
                // </div>
                <div className="add-issue-for-meeting">
                  <div className="add-upload-issue-container">
                    <div className="add-issue-item">
                      <div
                        className="add-issue-link"
                        onClick={this.showAddProjectModal}
                      >
                        <span>+</span>Add Project(s)
                      </div>
                      <div className="add-issue-desc">
                        Issues can be added after selecting the Projects
                      </div>
                    </div>
                    {/* <div className="add-issue-text">
                                      <div className="border-dashed-circle">OR</div>
                                    </div> */}
                    <div className="divider">
                      <div className="add-issue-text">
                        <div className="border-dashed-circle">
                          <div className="circle-txt">OR</div>
                        </div>
                      </div>
                    </div>
                    <div className="add-issue-item">
                      <div
                        className="add-issue-link"
                        //onClick={this.openUploadPopup}
                        onClick={() => this.openUploadPopup(false)}
                      >
                        <span>
                          {" "}
                          <Image src={UploadIcon} alt="Upload Icon" />
                        </span>
                        Upload Project(s)
                      </div>
                      <div className="add-issue-desc">
                        Upload Projects and Issues through excel file
                      </div>
                      <div
                        className="add-issue-subdesc-downld"
                        style={{ marginLeft: 50 }}
                      >
                        Download Template:{" "}
                        <div
                          className="download-excel-component upload-agenda"
                          style={{ border: "none" }}
                        >
                          <DownloadExcelReport
                            //iconClassName="doc-icon"
                            isLoading={
                              uploadAgendaTmp && uploadAgendaTmp.isLoading
                            }
                            downloadLink={
                              uploadAgendaTmp && uploadAgendaTmp.downloadingSrc
                            }
                            onClearDownload={
                              clearDownloadUpdaloadAgendaTemplateAction
                            }
                            onStartDownloading={() =>
                              downloadUpdaloadAgendaTemplateAction()
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="added-issue-list added-project-issue-list">
                  {/* {(selectedIssues || []).map((issue, index) => (
                    <SelectIssueSingle
                      issue={issue}
                      idx={index}
                      key={index}
                      deleteHandler={this.deselectIssues}
                      fromCreateAgendaPage={true}
                      IssueSelected="delete"
                    />
                  ))} */}
                  {(selectedProjectIssues || []).map((itemProject, index) => (
                    <ProjectIssueSingle
                      project={itemProject}
                      idx={index}
                      key={index}
                      deleteHandler={this.deselectProjects}
                      deleteIssueHandler={this.deselectIssues}
                      //fromCreateAgendaPage={true}
                      permission={permission}
                      meetingStatus={agendaStatus}
                      fromAgendaDetailPage={false}
                    />
                  ))}
                </div>
              )}
            </div>
            {toggleUploadDisplay ? (
              <UploadProjectsIssuesComponent
                key={toggleUploadDisplay}
                onUploadToggle={this.closeUploadPopup}
                toggleUploadDisplay={toggleUploadDisplay}
                isCustom={isCustom}
                customSection={downloadTemplateBlock}
                uploadedProjectissues={selectedProjectIssues}
              />
            ) : null}
            {/* {toggleBrowseDisplay ? (
              <UploadProjectsIssuesComponent
                isCustom={true}
                key={toggleBrowseDisplay}
                onUploadToggle={this.closeBrowseUploadPopup}
                toggleUploadDisplay={toggleBrowseDisplay}
              />
            ) : null} */}
            {showUploadedResultModal && (
              <UploadedListModal
                show={showUploadedResultModal}
                closeModal={this.closeUploadedListModal}
                alreadySelected={selectedProjectIssues}
                addInAgenda={this.addProjectIssuesToAgenda}
              />
            )}
            {showUploadErrorModal && (
              <UploadErrorModal
                show={showUploadErrorModal}
                closeModal={this.closeUploadErrorModal}
                addInAgenda={this.addProjectIssuesToAgenda}
              />
            )}

            {(get(user, "groupCategory") == "PMG" ||
              get(user, "groupCategory") == "STATE_PMG") && (
              <div className="guest-list-wrapper">
                <div className="select-guest-wrapper">
                  <h2 className="page-orange-bar">
                    Select Guest(s) <span className="required">*</span>
                  </h2>
                  <div className="guest-list-group-wrapper">
                    {/* <GuestList
                        selectedGuests={selectedGuests}
                        issueDetails={selectedIssues}
                        updatedSelectedGuest={this.updatedSelectedGuest}
                        originalGuestList={this.originalGuestList}
                      /> */}
                    <AgendaGuestList
                      selectedGuests={selectedGuests}
                      issueDetails={selectedProjectIssues}
                      updatedSelectedGuest={this.updatedSelectedGuest}
                      originalGuestList={this.originalGuestList}
                    />
                  </div>
                </div>
                <div className="selected-guest-wrapper">
                  <h2 className="page-orange-bar">Selected Guest(s)</h2>
                  <SelectedGuestList
                    selectedGuests={selectedGuests}
                    deleteGuests={this.deleteGuests}
                  />
                </div>
              </div>
            )}
            <div className="button-group">
              <div>
                {(get(user, "groupCategory") == "PMG" ||
                  get(user, "groupCategory") == "STATE_PMG" ||
                  get(user, "groupCategory") == "CENTRAL" ||
                  get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
                  get(user, "groupCategory") == "STATE") && (
                  <DisplayByPermission
                    display={!get(permission, "canViewOnlyProject")}
                  >
                    <Button
                      className="btn-orange no-padding"
                      onClick={() => {
                        this.setState(
                          { dataUnsaved: false },
                          this.validateError.bind(this, this.submitAgenda)
                        );
                      }}
                    >
                      Schedule Agenda
                    </Button>
                  </DisplayByPermission>
                )}
                <Button
                  className="btn-orange-invert no-padding"
                  onClick={() => {
                    this.setState(
                      { dataUnsaved: false },
                      this.saveAsDraftValidator.bind(this, this.saveAsDraft)
                    );
                  }}
                >
                  {" "}
                  {get(user, "groupCategory") == "PMG" ||
                  get(user, "groupCategory") == "STATE_PMG" ||
                  get(user, "groupCategory") == "CENTRAL" ||
                  get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
                  get(user, "groupCategory") == "STATE"
                    ? "Save as Draft"
                    : "Save"}
                </Button>
              </div>
              {/* {agendaId ? <DownloadAgendaBrief id={agendaId} /> : null}
              {agendaId ? <DownloadAgenda id={agendaId} /> : null} */}
              {formData && formData.id ? (
                <Button
                  className="btn-orange-invert no-padding delete-agenda"
                  onClick={() => {
                    this.setState({ dataUnsaved: false }, this.deleteAgenda);
                  }}
                >
                  <div className="delete-icon orange" /> Delete Agenda
                </Button>
              ) : null}
            </div>
          </div>
        </div>
        <SelectProjectOrdering
          title="Set Order"
          isLoading={false}
          centralProjectIdList={centralProjectIdList}
          stateProjectIdList={stateProjectIdList}
          projectIdList={projectIdList}
          setFinalOrderingForState={this.setFinalOrderingForState}
          setFinalOrderingForCentral={this.setFinalOrderingForCentral}
          show={showSelectOrderingModal}
          onSubmit={this.onApplyOrder}
          onClose={this.onToggleSelectOrdering}
          updatePresetForCentral={this.updatePresetForCentral}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageInfo: state.createAgendaReducer.pageInfo,
    agendaDetails: state.momReducer.data,
    agendaMeetingPptv2: state.donwloadExcelReducer.agendaMeetingPptv2,
    agendaMeetingPpt: state.donwloadExcelReducer.agendaMeetingPpt,
    agendaMeetingExcel: state.donwloadExcelReducer.agendaMeetingExcel,
    permissionsListing: state.commonReducer.permissionsListing,
    agendaMeetingPptv2WithoutIssue:
      state.donwloadExcelReducer.agendaMeetingPptv2WithoutIssue,
    agendaMeetingCabSecPpt: state.donwloadExcelReducer.agendaMeetingCabSecPpt,
    agendaMeetingPptv2PragatiFormat:
      state.donwloadExcelReducer.agendaMeetingPptv2PragatiFormat,
    uploadAgendaTmp: state.donwloadExcelReducer.uploadAgendaTmp,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createMom: createMom,
      loadPageInfo: loadPageInfo,
      getMomDetails: getMomDetails,
      clearMomDetails: clearMomDetails,
      updateMom: updateMom,
      guestListDispatch: guestListAction,
      deleteMOM: deleteMOM,
      downloadAgendaMeetingPptv2,
      clearDownloadAgendaMeetingPptv2Action,
      clearDownloadAgendaMeetingCabSecPptAction,
      downloadAgendaMeetingPpt,
      clearDownloadAgendaMeetingPptAction,
      downloadAgendaMeetingExcel,
      clearDownloadAgendaMeetingExcelAction,
      getMeetingTypesDetails,
      clearDownloadAgendaMeetingPptv2WithoutIssueAction,
      downloadAgendaCabSecPpt,
      downloadAgendaMeetingPptv2PragatiFormat,
      clearDownloadAgendaMeetingPptv2PragatiFormatAction,
      getUpcommingAgendaFlagDispatch: getUpcommingAgendaFlagAction,
      clearDownloadUpdaloadAgendaTemplateAction,
      downloadUpdaloadAgendaTemplateAction
    },
    dispatch
  );
}

export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CreateAgenda)
  )
);
